// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2njV1","label":"Radio_label__14gwR","checkMark":"Radio_checkMark__xwkxa","disabled":"Radio_disabled__xuZt0"};